import { SplitLayout } from "@components/molecules/SplitLayout";
import { CarFinance } from "@components/organisms/CarFinance";
import Text from "@components/atoms/Text";
import styles from "@components/organisms/MMV/MMVCarLoan/MMVCarLoan.module.scss";

interface MMVCarLoanProps {
  price: any;
  carFinanceData: any;
  carFinanceBankData: any;
  isLoggedIn: boolean;
  brandName: string;
  modelName : string;
  variantName : string;
  cityName : string;
  isSellable : boolean;
  pageType : string;
  carAvailability?: string;
}

export default function MMVCarLoan({ price, carFinanceData,carFinanceBankData, isLoggedIn, brandName, modelName, variantName, pageType, isSellable, cityName, carAvailability,}: MMVCarLoanProps) {
  const { market_price: onRoadPrice, adsp_price: ackoDrivePrice, savings: savings, savings_breakup: savingsBreakup } = price || {};
  const {finance_provider: financeProvider} = carFinanceBankData;
  const defaultProviderId = carFinanceData?.car_finance?.default_bank_id;
  const selectedFinanceProvider = financeProvider?.find(
    (provider: { id: any }) => provider.id === defaultProviderId
  );
  const carFinanceValuePropositions =
    carFinanceData?.car_finance?.value_propositions || [];

  return (
    <>
      <SplitLayout className={styles.splitContainer}>
        <div className={styles.leftSection}>
          <Text level="p" className={styles.title}>
            {`Get a car loan with ACKO Drive  @ ₹12,343/month`}
          </Text>
        </div>
        <div className={styles.rightSection}>
          <CarFinance
            isLoggedIn={isLoggedIn}
            savingsBreakupData={savingsBreakup}
            onRoadPrice={Number(onRoadPrice)}
            // ADPrice={Number(ackoDrivePrice)}
            carFinanceValuePropositions={carFinanceValuePropositions}
            carFinanceData={carFinanceData}
            carFinanceBankData={financeProvider}
            selectedBankValue={selectedFinanceProvider}
            maxSavings={
              carFinanceData?.car_finance?.max_ackodrive_finance_saving
            }
            brandName={brandName}
            modelName={modelName}
            variantName={variantName}
            cityName={cityName}
            isSellable={isSellable}
            pageType={pageType}
            carAvailability={carAvailability}
          />
        </div>
      </SplitLayout>
    </>
  );
}
